/* Artezaib (Oct 2026 draft): the old FastClick library was removed from this file.
   FastClick is an outdated script that makes text boxes, dropdowns and buttons need several taps on modern iPhones and Android phones.
   Modern phones do not need it. This small stand-in keeps the rest of the theme working (timber.js still calls FastClick.attach).
   This file is loaded on every page, so it also carries the mobile tap-size fixes for the flooring and framing calculators,
   and adds the "delivery is not included" line under the flooring calculator estimate (delivery is NOT added to the total). */
(function(){
  function FastClick(){}
  FastClick.prototype.destroy = function(){};
  FastClick.attach = function(){ return new FastClick(); };
  FastClick.notNeeded = function(){ return true; };
  window.FastClick = FastClick;

  var css = ''
  + 'html{touch-action:manipulation}'
  + '#az-calc select,#az-calc input[type=number],#az-calc input[type=text],#az-calc input[type=tel],#az-calc input[type=email]{font-size:16px;min-height:54px;padding:14px 12px;border:1.5px solid #bdb5aa;border-radius:6px;box-sizing:border-box}'
  + '#az-fcalc select,#az-fcalc input[type=number]{font-size:16px;min-height:54px;padding:14px 12px;border:1.5px solid #bdb5aa;border-radius:6px;box-sizing:border-box}'
  + '#az-calc input:focus,#az-calc select:focus,#az-fcalc input:focus,#az-fcalc select:focus{border-color:#b69169;outline:2px solid rgba(182,145,105,.35)}'
  + '#az-calc label,#az-fcalc label{font-size:15px}'
  + '#az-calc .az-tabs button{min-height:50px;font-size:15px}'
  + '#az-calc .az-labonly{min-height:44px;font-size:15px}'
  + '#az-calc .az-labonly input{width:24px;height:24px;min-height:0;padding:0;flex:0 0 24px}'
  + '#az-calc .az-rng{min-height:56px;padding:12px}'
  + '#az-calc .az-hint,#az-fcalc .az-hint{font-size:13px}'
  + '#az-fcalc .az-sizes{gap:8px}'
  + '#az-fcalc .az-sizes button{min-height:44px;padding:8px 16px;font-size:15px;border-radius:22px}'
  + '#az-fcalc .az-seg button{min-height:50px}'
  + '@media(max-width:600px){#az-calc .az-calc-in,#az-calc .az-calc-out{padding:18px 14px}#az-calc .az-row,#az-fcalc .az-row{gap:8px}}';
  try {
    var s = document.createElement('style');
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  } catch (e) {}

  function setup(){
    var dec = ['azc-l','azc-w','azc-area','fc-w','fc-h'], i, el;
    for (i = 0; i < dec.length; i++) { el = document.getElementById(dec[i]); if (el) el.setAttribute('inputmode', 'decimal'); }
    el = document.getElementById('azc-qr'); if (el) el.setAttribute('inputmode', 'numeric');
    var note = document.querySelector('#azc-out .az-note');
    if (note && !document.getElementById('azc-delnote')) {
      var d = document.createElement('span');
      d.id = 'azc-delnote';
      d.innerHTML = ' <strong>Delivery is not included:</strong> free on orders of $3,000 or more, and free to $150 for smaller orders depending on size and weight. Showroom pickup is free.';
      note.appendChild(d);
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setup); } else { setup(); }
})();
